import React from 'react';
import moment from 'moment';
import {Checkbox, Icon, Modal, Pagination, Tooltip} from 'antd';
import { PageSizeOptionsString } from '../../APIModels/BaseParams';
import {ellipsis, formatDate} from "../../util/UtilFunction";

export class FMKArticlesTable extends React.Component {
    constructor(props) {
        super(props)

        this.showSizeChange = this.showSizeChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
    }

    goToEdit(id, e) {
        e.stopPropagation();
        window.open("/archive/articles/edit?id=" + id, "_self")
    }

    goToDetail(id, e) {
        e.stopPropagation();
        window.open("/archive/article/detail?id=" + id, "_self")
    }

    goToEdition(id, e){
        e.stopPropagation();
        window.open('/archive/edition/detail?id=' + id, "_self" )
    }

    showModal(id, name, e) {
        e.stopPropagation();
        this.props.setModal(true, "Delete", id, 'Delete article: ' + name + '?')
    }

    handleOk(id, type) {
        this.props.setModal(false, '', null, null)
        switch (type.toLowerCase()) {
            case 'delete' :
                this.props.deleteArticle(id, false)
                break;
            case 'massive delete' :
                this.props.deleteArticle(id, true)
                break;
            case 'publish':
                this.props.setOnline(id, true)
                break;
            case 'unpublish':
                this.props.setOnline(id, false)
                break;

        }
    }

    handleCancel() {
        this.props.setModal(false, '', null, null)
    }

    showSizeChange(current, size) {
        this.props.setPagination(size, current)
    }

    pageChange(page, size) {
        this.props.setPagination(size, page)
    }

    render() {
        let modal =
            <Modal title={this.props.modalTitle} visible={this.props.modalOpen} onOk={() => this.handleOk(this.props.modalId, this.props.modalTitle)} onCancel={() => this.handleCancel()}>
                <p>{this.props.modalContent}</p>
            </Modal>

        let thead =
            <tr>
                {this.props.showCheckbox && (
                    <th style={{width: '1%'}}></th>
                )}
                {!this.props.isEditionPage && (
                    <th style={{width: '10%'}}><p style={{whiteSpace: "nowrap", marginBottom: '0'}}>Magazine</p></th>
                )}
                {!this.props.isEditionPage && (
                    <th style={{width: '5%'}}><p style={{whiteSpace: "nowrap", marginBottom: '0'}}>Date</p></th>
                )}
                {!this.props.isEditionPage && (
                    <th style={{width: '1%'}}><p style={{whiteSpace: "nowrap", marginBottom: '0'}}>Number</p></th>
                )}
                <th style={{width: '5%'}}>Page</th>
                <th style={{width: '15%'}}>Subhead</th>
                <th>Title</th>
                <th style={{width: this.props.isEditionPage ? '30%' : '10%'}}>Summary</th>
                <th style={{width: '10%'}}>Signature</th>
                <th style={{width: '1%'}}>Published</th>
                {this.props.showActions && (
                    <th style={{width: '8%'}}></th>
                )}
            </tr>

        return (
            <div className="tableContainer">
                {this.props.articles && this.props.articles.length > 0 ? (
                    <div>
                        <table className='table fmk_table table-striped my-4'>
                            <thead>
                                {thead}
                            </thead>
                            <tbody>
                                {this.props.articles.map((article) => {
                                    return (
                                        <tr key={article.id} onClick={(e) => this.goToDetail(article.id, e)}>
                                            {this.props.showCheckbox && (
                                                <td>
                                                    <Checkbox onClick={(e) => e.stopPropagation()}
                                                              onChange={() => this.props.selectRow(article.id)}
                                                              checked={this.props.selectedRow.includes(article.id)}>
                                                    </Checkbox>
                                                </td>
                                            )}
                                            {!this.props.isEditionPage && (
                                                <td>{article.edition.magazine.name}</td>
                                            )}
                                            {!this.props.isEditionPage && (
                                                <td>{formatDate(article.edition.competenceDateFrom, 'MM/YYYY')}</td>
                                            )}
                                            {!this.props.isEditionPage && (
                                                <td>
                                                    <div className="fmk_link"
                                                        onClick={(e) => this.goToEdition(article.edition.id, e)}>
                                                        {article.edition.number}
                                                    </div>
                                                </td>
                                            )}
                                            <td>da {article.pageFrom} a {article.pageTo}</td>
                                            <td>{ellipsis(article.occhiello, 40)}</td>
                                            <td>
                                                <Tooltip placement="topLeft" title={article.title} arrowPointAtCenter>
                                                    {ellipsis(article.title, 50)}
                                                </Tooltip>
                                            </td>
                                            <td>
                                                <Tooltip placement="topLeft" title={article.summary} arrowPointAtCenter>
                                                    {ellipsis(article.summary, 40)}
                                                </Tooltip>
                                            </td>
                                            <td>{article.signature}</td>
                                            <td>
                                            {article.isOnline ? (
                                                <Tooltip placement="topLeft" title="Online" arrowPointAtCenter>
                                                    <Icon type="check-circle" className="text-success" />
                                                </Tooltip>
                                            ) : (
                                                <Tooltip placement="topLeft" title="Offline" arrowPointAtCenter>
                                                    <Icon type="close-circle-o" className="text-danger" />
                                                </Tooltip>
                                            )}
                                            </td>
                                            {this.props.showActions && (
                                                <td style={{fontSize: 18}}>
                                                    {article.files != null && (
                                                        <Tooltip placement="topLeft" title="With attach" arrowPointAtCenter>
                                                            <Icon type="paper-clip" />
                                                        </Tooltip>
                                                    )}
                                                    <Tooltip placement="topLeft" title="Edit" arrowPointAtCenter>
                                                        <Icon type="edit" className="mx-2"
                                                              onClick={(e) => this.goToEdit(article.id, e)}/>
                                                    </Tooltip>
                                                    <Tooltip placement="topLeft" title="Delete" arrowPointAtCenter>
                                                        <Icon type="delete"
                                                              onClick={(e) => this.showModal(article.id, article.title, e)}/>
                                                    </Tooltip>
                                                </td>
                                            )}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        <Pagination className="FMKPagination mb-4" showSizeChanger hideOnSinglePage
                                    pageSizeOptions={PageSizeOptionsString} onChange={this.pageChange}
                                    onShowSizeChange={this.showSizeChange} size="small"
                                    total={this.props.paramResponse.totalItems}/>
                    </div>
                ) : (
                    //NothingFound
                    <h3 className="text-center">{this.props.fetchFinish ? 'Nothing found' : ''}</h3>
                )}

                {modal}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/FMKArticlesTable.js